import { RankingParams } from '@/@dtos/search-result.dto';
import { Ranking } from '@patsnap-biz/refine-filter/src/Ranking';
import filterRankingData from 'library-@/utils/filterRankingData';
import { getleftFilterRankingApi } from 'library-@/apis/core_basic_api/search.js';


export async function getRanking(params: RankingParams): Promise<[Ranking.Field]> {
    const { data } = await getleftFilterRankingApi({
        ...params,
        ...window.THIRD_PARTY_PARAMS
    });
    // @ts-ignore
    return filterRankingData(data.data || []);
}

/**
 * @deprecated
 */
export default getRanking
